import { getHeaderComponent } from "@/src/api/services/component";
import { Header } from "@/src/components/Header";

export const HeaderFetchWrapper = async () => {
    const headerData = await getHeaderComponent();
    if (!headerData) return null;

    return !headerData.hidden ? <Header {...headerData.props} /> : null;
};
